export default __webpack_public_path__ + "static/avatar1-51c33fae8c88288dcec5b351c508da12.png";